<template>

<div class="row">
<router-link :to="'/Categories'">
<img :src="'./static/img/logo.png'" class="img-responsive center-block" width="650" style="margin-top:150px;margin-bottom:100px;">

<h1>THE DECO DIFFERENCE<br>IS IN THE DETAILS</h1>
<h2>
  Leading design, elegant accents and superior features and finishes are the signature of every DECO Home.
</h2>
<h3>TOUCH TO ENTER</h3>

<img :src="'./static/img/hand-icon.gif'" class="img-responsive center-block" width="120" >
</router-link>
</div>

</template>

<script>

export default {
  name: 'Landing',
  data () {
    return {
      msg: 'Welcome to Landing page!'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  color:#d9272e;
  font-size: 100px;
  letter-spacing: 3px;
}
h2{
  font-family: 'ralewaysemibold';
  font-size: 40px;
  font-style: italic;
  line-height: 50px;
  margin:70px;
}

h3{
  color:#d9272e;
  font-size: 40pt;
  font-weight: 100;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/Landing.vue